import { schema } from 'normalizr';
import {
  entitiesSelectorList,
  entitiesSelectorItem,
} from '../utils/asyncHelpers';

const schemaEntity = new schema.Entity('productionUnitCertificate', undefined, {
  idAttribute: 'file',
});

export const getProductionUnitCertificates = entitiesSelectorList(schemaEntity);
export const getProductionUnitCertificate = entitiesSelectorItem(schemaEntity);
export default schemaEntity;
